import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'app/AppStore';
import { SDivider } from 'components/Login/LoginForm/LoginForm.styled';
import { getEstimateTotalPrice, getValidRowTablesCount } from 'domains/estimate/Estimate.store';
import { getCurrency } from 'domains/user';
import { Flex, LightCard, SPACE_BETWEEN, Text } from 'UI';
import { textFormatter } from 'utils/format';

export interface TotalSectionProps {
  estimateId: string;
}

const SECTION_BOLD = 'section_bold';

const TotalSection = ({ estimateId }: TotalSectionProps) => {
  const { t } = useTranslation();
  const numberOfItems = useSelector((state: RootState) => getValidRowTablesCount(state, estimateId));
  const priceDetail = useSelector((state: RootState) => getEstimateTotalPrice(state, estimateId));
  const currency = useSelector(getCurrency);
  return (
    <LightCard
      title={<Trans i18nKey="estimate.pdf.estimate_total_items">Estimate total: {{ numberOfItems }} items</Trans>}
    >
      <Flex justify={SPACE_BETWEEN}>
        <Text type={SECTION_BOLD}>{`${t('common.price.total_VAT_excl', 'Total VAT. Excl')}:`}</Text>
        <Text type="base">{textFormatter.formatCurrency(priceDetail.priceVatExcluded, currency)}</Text>
      </Flex>
      <Flex justify={SPACE_BETWEEN}>
        <Text type={SECTION_BOLD}>{t('common.price.vat', 'VAT:')}</Text>
        <Text type="base">{textFormatter.formatCurrency(priceDetail.vat, currency)}</Text>
      </Flex>
      {Number(priceDetail.discount) > 0 && (
        <Flex justify={SPACE_BETWEEN}>
          <Text type={SECTION_BOLD}>{`${t('common.discount', 'Discount')}:`}</Text>
          <Text type="base">{textFormatter.formatCurrency(priceDetail.discount, currency)}</Text>
        </Flex>
      )}
      <SDivider />
      <Flex justify={SPACE_BETWEEN}>
        <Text type={SECTION_BOLD}>{`${t('common.price.total_vat_incl', 'Total VAT. Incl')}:`}</Text>
        <Text type="base">{textFormatter.formatCurrency(priceDetail.priceVatIncluded, currency)}</Text>
      </Flex>
    </LightCard>
  );
};

export default TotalSection;
